import brandConfig from '~branding/austrian/config.js'
import TermsOfUsePage from '~brand-pages/austrian/terms-of-use'
import VoucherSaleAmountPage from '~brand-pages/austrian/voucher-sale-amount'
import VoucherSaleCheckoutPage from '~brand-pages/austrian/voucher-sale-checkout'
import VoucherSaleConfirmationPage from '~brand-pages/austrian/voucher-sale-confirmation'
import VoucherSaleLandingPage from '~brand-pages/austrian/voucher-sale'
import WithdrawalPage from '~brand-pages/austrian/withdrawal'

import routerBuilder from './routerBuilder'

const router = routerBuilder('austrian', {
  brandConfig,
  TermsOfUsePage,
  TermsOfUsePageCompensation: null,
  VoucherSaleAmountPage,
  VoucherSaleCheckoutPage,
  VoucherSaleConfirmationPage,
  VoucherSaleLandingPage,
  WithdrawalPage,
}, ['en', 'de'])

export default router
